import script from "./TheAccountMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./TheAccountMessage.vue?vue&type=script&setup=true&lang=js"

import "./TheAccountMessage.vue?vue&type=style&index=0&id=f4d3c34a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4d3c34a"]])

export default __exports__